"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputText = void 0;
const react_1 = __importStar(require("react"));
const vobaza_ui_icon_1 = require("@nebo-team-dev/vobaza.ui.icon");
const input_text_styled_1 = require("./input-text.styled");
var ValueTypes;
(function (ValueTypes) {
    ValueTypes["all"] = "all";
    ValueTypes["integer"] = "integer";
    ValueTypes["decimal"] = "decimal";
})(ValueTypes || (ValueTypes = {}));
const checkIsInteger = (value) => {
    if (!value)
        return true;
    const regexp = /^\d+$/g;
    return regexp.test(value);
};
const checkIsDecimal = (value) => {
    if (!value)
        return true;
    return Number.isFinite(Number(value));
};
const validatorsValueByType = {
    [ValueTypes.integer]: checkIsInteger,
    [ValueTypes.decimal]: checkIsDecimal,
};
function InputText(_a) {
    var { label, name, value, error, type = 'text', disabled = false, readonly = false, multiline = false, notion, required, valueType = 'all', icon, isColoredIcon, isClickableIconWithValue, onChange, onBlur, onClick, onClickIcon } = _a, props = __rest(_a, ["label", "name", "value", "error", "type", "disabled", "readonly", "multiline", "notion", "required", "valueType", "icon", "isColoredIcon", "isClickableIconWithValue", "onChange", "onBlur", "onClick", "onClickIcon"]);
    const textArea = (0, react_1.useRef)(null);
    const handleChange = (event) => {
        const validator = validatorsValueByType[valueType];
        if (validator && !validator(event.target.value)) {
            event.target.value = value || '';
        }
        if (validator) {
            event.target.value = event.target.value.replace(/\s/g, '');
        }
        onChange && onChange(event);
    };
    const handleBlur = (event) => {
        if (valueType === ValueTypes.decimal) {
            if (value && value.toString().slice(-1) === '.') {
                const pseudoEvent = {
                    target: { name, value: value.toString().slice(0, -1) },
                };
                onChange && onChange(pseudoEvent);
            }
        }
        onBlur && onBlur(event);
    };
    const autoresizeTextarea = ($el) => {
        if (!$el)
            return;
        $el.style.height = 'auto';
        const scrollHeight = $el.scrollHeight;
        $el.style.height = `${scrollHeight + 2}px`;
    };
    (0, react_1.useEffect)(() => {
        textArea.current && autoresizeTextarea(textArea.current);
    }, [value]);
    const renderIcon = () => {
        let clickable = true;
        if (isClickableIconWithValue) {
            clickable = clickable && !!value;
        }
        const addHandleClickIcon = () => {
            return (e) => {
                e.preventDefault();
                if ((onClickIcon || onClick) && clickable) {
                    onClickIcon ? onClickIcon() : onClick(e);
                }
            };
        };
        if (icon)
            return (react_1.default.createElement(input_text_styled_1.StyledIconWrapper, { type: "button", disabled: disabled, isColored: isColoredIcon, clickable: clickable, onClick: addHandleClickIcon() },
                react_1.default.createElement(vobaza_ui_icon_1.Icon, { name: icon })));
    };
    return (react_1.default.createElement(input_text_styled_1.StyledField, null,
        react_1.default.createElement(input_text_styled_1.StyledInputWrap, { disabled: disabled, hasError: error },
            multiline ? (react_1.default.createElement(input_text_styled_1.StyledTextarea, Object.assign({ ref: textArea, id: name, name: name, value: value === null ? '' : value, rows: "1", placeholder: props.placeholder || ' ', disabled: disabled, readOnly: readonly, hasError: error, withIcon: !!icon, onClick: onClick, onChange: handleChange, onBlur: handleBlur }, props))) : (react_1.default.createElement(input_text_styled_1.StyledInput, Object.assign({ id: name, name: name, value: value === null ? '' : value, placeholder: props.placeholder || ' ', type: type, withIcon: !!icon, disabled: disabled, readOnly: readonly, hasError: error, onClick: onClick, onChange: handleChange, onBlur: handleBlur }, props))),
            react_1.default.createElement(input_text_styled_1.StyledLabelWrapper, { htmlFor: name },
                react_1.default.createElement(input_text_styled_1.StyledLabel, null, label),
                required && react_1.default.createElement(input_text_styled_1.StyledRequiredStar, null, "*")),
            renderIcon()),
        react_1.default.createElement(input_text_styled_1.StyledNotion, { hasError: error }, error || notion)));
}
exports.InputText = InputText;
//# sourceMappingURL=input-text.js.map